import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@linktivity/link-ui';
import { Back, CancelTerms } from '@triplabo/web/components';
import { CancelOrderTaxi } from '@triplabo/web/assets';
import ArrowRight from '@triplabo/web/assets/arrow_right.svg?react';
import styles from './cancel.module.css';

interface CancelOrderProps {
  cancelFee?: number;
  onCancel: () => void;
  onSelectReason: () => void;
}

const CancelOrder: FC<CancelOrderProps> = ({
  onCancel,
  onSelectReason,
  cancelFee
}) => {
  const { t } = useTranslation();
  const [showCancelTerms, setShowCancelTerms] = useState(false);
  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleSelectReason = useCallback(() => {
    onSelectReason();
  }, [onSelectReason]);

  const goToCancelRule = useCallback(() => {
    setShowCancelTerms(true);
  }, []);

  return (
    <div className={styles.wrap}>
      {showCancelTerms && (
        <CancelTerms onClose={() => setShowCancelTerms(false)} />
      )}
      <Back
        onBack={handleCancel}
        inline
        title={t('views.cancelOrder.confirmCancel.title')}
      />
      <div className={styles.content}>
        <img src={CancelOrderTaxi} alt="taxi" className={styles.taxiImage} />
        <p className={styles.warning}>
          {t('views.cancelOrder.confirmCancel.warning')}
        </p>
        {cancelFee ? (
          <p className={styles.cancelFee}>
            {t('views.cancelOrder.confirmCancel.cancelFee')}
            <span className={styles.cancelFeeAmount}>
              {t('views.cancelOrder.confirmCancel.cancelFeeDescription', {
                amount: cancelFee
              })}
            </span>
          </p>
        ) : null}
        <p className={styles.note}>
          {t('views.cancelOrder.confirmCancel.note')}
        </p>
        <div className={styles.rules} onClick={goToCancelRule}>
          <span>{t('views.cancelOrder.confirmCancel.viewRules')}</span>
          <ArrowRight className={styles.arrowRight} />
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          className={styles.confirmBtn}
          variant="outlined"
          onClick={handleSelectReason}
        >
          {t('views.cancelOrder.confirmCancel.confirm')}
        </Button>
        <Button className={styles.cancelBtn} onClick={handleCancel}>
          {t('views.cancelOrder.confirmCancel.waitMore')}
        </Button>
      </div>
    </div>
  );
};

export default CancelOrder;
